<template>
  <div>
    <nba-summary
      :Position="Profile"
      :stats="stats"
      :seasonStats="seasonStats"
      v-if="sportId == 1"
    />
    <mlb-summary
      :Position="Profile"
      :stats="stats"
      :seasonStats="seasonStats"
      v-if="sportId == 2"
    />
    <nhl-summary
      :Position="Profile"
      :stats="stats"
      :seasonStats="seasonStats"
      v-if="sportId == 3"
    />
    <nfl-summary
      :Position="Profile"
      :stats="stats"
      :seasonStats="seasonStats"
      v-if="sportId == 4"
    />
  </div>
</template>

<script>
import MlbSummary from "./playerSummary/MlbSummary.vue";
import NbaSummary from "./playerSummary/NbaSummary.vue";
import NflSummary from "./playerSummary/NflSummary.vue";
import NhlSummary from "./playerSummary/NhlSummary.vue";

export default {
  name: "Summary",
  components: { NhlSummary, NflSummary, MlbSummary, NbaSummary },
  props: {
    stats: {
      type: [Array, Object],
      default: () => [],
    },
    seasonStats: {
      type: [Array, Object],
      default: () => [],
    },
    sportId: {
      type: [String, Number],
      default: "",
    },
    Profile: {
      type: Object,
      default: () => {},
    },
  },
};
</script>

<style scoped>
.basil {
  background-color: #fffbe6 !important;
}

.basil--text {
  color: #356859 !important;
}
</style>
